module.exports = __webpack_public_path__ + "static/media/effects.caabf698.md";